import { Center, Divider, GridItem, Text } from "@chakra-ui/react";
import { indexToLetter, SUB_LEVER_PARAMETERS } from "../../../helpers";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { FormSwitch } from "../../../../../components/Forms";

function SubLeverGridItem({ lever, subLever, subLeverIndex, register, control, submitSwitchChange }) {
  const { t } = useTranslation("translation", { keyPrefix: "decarbonization.page" });

  return (
    <>
      <GridItem />
      <GridItem colSpan={8}>
        <Text fontSize="sm">{`${indexToLetter(subLeverIndex)}. ${subLever.name}`}</Text>
      </GridItem>
      {subLever.selections && subLever.selections.map(selection => {
        return <GridItem display="flex" colSpan={2} justifyContent="center"
                         key={`lever-${lever.id}-sub-lever-${subLever.id}-pathway-${selection.pathwayId}`}>
          <Center>
            <FormSwitch
              {...register(`lever-${lever.id}-sub-lever-${subLever.id}-pathway-${selection.pathwayId}`)}
              control={control}
              controlProps={{
                onChange: (e) => submitSwitchChange({
                  pathwayId: selection.pathwayId,
                  subLeverId: subLever.id,
                  selected: e.target.checked
                })
              }}
              styleProps={{
                size: "sm",
                colorScheme: "customScheme",
                transform: "rotate(270deg)"
              }}
              isDisabled={subLever[SUB_LEVER_PARAMETERS.emissionsSaved] === null}
              title={subLever[SUB_LEVER_PARAMETERS.emissionsSaved] === null ? t("disabledSwitchTooltip") : ""}
            />
          </Center>
        </GridItem>;
      })}
      <GridItem colSpan={19}>
        <Divider />
      </GridItem>
    </>
  );
}

export default SubLeverGridItem;